import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@style/service'
import { steps } from './steps'

export const NoraHomePageControl = ({
  stepIndex,
  isOverlay = false,
}: {
  stepIndex: number
  isOverlay?: boolean
}) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.pageControl} testID="nora-home-walkthrough-page-control">
      {Array.from({ length: steps.length }, (_dot, index) => (
        <View
          key={index}
          style={[
            styles.dot,
            isOverlay && styles.dotOverlay,
            index !== stepIndex && styles.dotInactive,
          ]}
        />
      ))}
    </View>
  )
}

const themedStyles = StyleService.create({
  pageControl: {
    flexDirection: 'row',
    gap: 5,
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: 4,
    backgroundColor: 'theme.text.primary',
  },
  dotOverlay: {
    backgroundColor: 'theme.solid.white',
  },
  dotInactive: {
    opacity: 0.35,
  },
})
